import Immutable from "immutable";

export const LOCAL_VARIABLE_SCOPE = "local";
export const GLOBAL_VARIABLE_SCOPE = "global";
export const META_VARIABLE_SCOPE = "meta";
export const OAUTH_VARIABLE_SCOPE = "oauth";
export const INTERNAL_VARIABLE_SCOPE = "internal";
export const HEADERS_VARIABLE_SCOPE = "headers";
export const SENSITIVE_VARIABLE_SCOPE = "sensitive";

export const ALL_SCOPES = Immutable.List([
  LOCAL_VARIABLE_SCOPE,
  GLOBAL_VARIABLE_SCOPE,
  META_VARIABLE_SCOPE,
  OAUTH_VARIABLE_SCOPE,
  INTERNAL_VARIABLE_SCOPE,
  HEADERS_VARIABLE_SCOPE,
  SENSITIVE_VARIABLE_SCOPE
]);

export const NON_STANDARD_SCOPES = [
  META_VARIABLE_SCOPE,
  OAUTH_VARIABLE_SCOPE,
  INTERNAL_VARIABLE_SCOPE,
  HEADERS_VARIABLE_SCOPE
];

export const DELETABLE_VARIABLE_SCOPES = [
  LOCAL_VARIABLE_SCOPE,
  GLOBAL_VARIABLE_SCOPE,
  SENSITIVE_VARIABLE_SCOPE,
  // You can create/attach oauth/chatter variables in V1
  OAUTH_VARIABLE_SCOPE
];

// The scopes that should show in capture/request variable dropdowns
export const VARIABLE_SCOPES_IN_DROPDOWN = [
  LOCAL_VARIABLE_SCOPE,
  GLOBAL_VARIABLE_SCOPE,
  SENSITIVE_VARIABLE_SCOPE
];

// The scopes that should show in set variable block target variable dropdowns
export const VARIABLE_SCOPES_IN_DROPDOWN_SHOW_AUTH = [
  LOCAL_VARIABLE_SCOPE,
  GLOBAL_VARIABLE_SCOPE,
  OAUTH_VARIABLE_SCOPE
];

// The scopes that should show in conditionals/segmentation variable dropdowns
export const VARIABLE_SCOPES_IN_CONDITIONALS_DROPDOWN = [
  LOCAL_VARIABLE_SCOPE,
  GLOBAL_VARIABLE_SCOPE,
  HEADERS_VARIABLE_SCOPE,
  META_VARIABLE_SCOPE,
  OAUTH_VARIABLE_SCOPE,
  SENSITIVE_VARIABLE_SCOPE
];

// The scopes that should show in email selector variable dropdowns
export const VARIABLE_SCOPES_IN_EMAIL_SELECTOR_DROPDOWN = [
  LOCAL_VARIABLE_SCOPE,
  GLOBAL_VARIABLE_SCOPE,
  META_VARIABLE_SCOPE
];

// The scopes that should show in content variable selector dropdowns for the set variable block
export const VARIABLE_SCOPES_IN_CONTENT_SELECTOR_DROPDOWN = [
  LOCAL_VARIABLE_SCOPE,
  GLOBAL_VARIABLE_SCOPE,
  META_VARIABLE_SCOPE
];

// The scopes that should have the "always ask" option
export const VARIABLE_SCOPES_ALWAYS_ASK_OPTION = [
  GLOBAL_VARIABLE_SCOPE,
  SENSITIVE_VARIABLE_SCOPE
];

// The scopes that should have the dropdown arrow to open the edit menu
export const VARIABLE_SCOPES_EDITABLE = [
  LOCAL_VARIABLE_SCOPE,
  GLOBAL_VARIABLE_SCOPE,
  SENSITIVE_VARIABLE_SCOPE
];

/**
 * The types of modal that can be shown
 * when we warn about variable deletion
 */

export const DELETE_RESPONSE_WITH_VARIABLES = "DELETE_RESPONSE_WITH_VARIABLES";
export const CREATE_VARIABLE_DROPDOWN = "CREATE_VARIABLE_DROPDOWN";
export const CHANGE_VARIABLE_DROPDOWN = "CHANGE_VARIABLE_DROPDOWN";
export const DELETE_LANGUAGE_WITH_VARIABLES = "DELETE_LANGUAGE_WITH_VARIABLES";
export const DELETE_MESSAGE_WITH_VARIABLES = "DELETE_MESSAGE_WITH_VARIABLES";
export const REMOVE_VARIABLE_FROM_REQUEST_BLOCK = "REMOVE_VARIABLE_FROM_REQUEST_BLOCK";
